import { styled } from '@mui/material';

import { Screen } from '@/components/Layout/Screen';

export const Container = styled(Screen)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  '.MuiContainer-root': {
    display: 'flex',
    justifyContent: 'center',
  },
}));

export const IllustrationContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
}));

export const Content = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  '.MuiButton-root': {
    margin: `0 auto`,
    padding: `0 ${theme.spacing(2)} 0 ${theme.spacing(2)}`,
  },
}));
